lmApp.
  directive('lmTags', ['$window', '$document', '$timeout',
    function ($window, $document, $timeout) {
      return {
        restrict: 'E',
        replace: true,
        scope: {
          ngModel: '=',
          placeholder: '@',
          error: '@',
          errorFn: '&',
          warning: '@',
          warningFn: '&',
          success: '@',
          successFn: '&',
          ngDisabled: '=?',
          onFocus: '&',
          onBlur: '&'
        },
        link: function (scope, element, attrs) {
          scope._multi_element_ = element;
          scope._input_ = element.find('#tag_input');
          scope.newTag = '';

          if (typeof scope.errorFn !== 'function') {
            scope.errorFn = function () {
              return scope.errorFn;
            }
          }
          if (typeof scope.warningFn !== 'function') {
            scope.warningFn = function () {
              return scope.warningFn;
            }
          }
          if (typeof scope.successFn !== 'function') {
            scope.successFn = function () {
              return scope.successFn;
            }
          }

          if (!angular.isArray(scope.ngModel)) scope.ngModel = [];

          var _OnKeyDown = function (event) {

            // TAB - switch to another input
            if (event.which == 9) {
              if (event.preventDefault) event.preventDefault();
              if (event.stopPropagation) event.stopPropagation();
              scope.clearTagInput();
              scope._input_.blur();
              return;
            }

            // ENTER - select option and close when select options are opened
            if (event.which == 13) {
              if (event.preventDefault) event.preventDefault();
              if (event.stopPropagation) event.stopPropagation();
              scope.addTag(scope.newTag);
              scope._input_.focus();
              return;
            }

            // ESC - close options
            if (event.which == 27) {
              if (event.preventDefault) event.preventDefault();
              if (event.stopPropagation) event.stopPropagation();
              scope.clearTagInput();
              scope._input_.blur();
              return;
            }
          };

          var _onFocus = function () {
            angular.element('body').bind('keydown', _OnKeyDown);
          };

          var _onBlur = function () {
            $timeout(function () {
              scope.addTag(scope.newTag);
            }, 150);
            angular.element('body').unbind('keydown', _OnKeyDown);
          };

          scope.clearTagInput = function () {
            scope.newTag = '';
            $timeout(function () {
              scope._input_.focus();
            });
          };

          scope.focusInput = function () {
            $timeout(function () {
              scope._input_.focus();
            });
          };

          scope.addTag = function (input) {
            var tags = input.split(',');

            tags.forEach(function (tag) {
              var index = scope.ngModel.indexOf(tag);

              if (index === -1 && tag) {
                scope.ngModel.push(tag);
              }
            });

            $timeout(function () {
              scope.newTag = '';
            });
          };

          scope.removeTag = function (tag) {
            var index = scope.ngModel.indexOf(tag);

            if (index !== -1) {
              scope.ngModel.splice(index, 1);
            }
          };

          scope._input_.bind('focus', _onFocus);
          scope._input_.bind('blur', _onBlur);

          scope._multi_element_.on('$destroy', function () {
            scope._input_.unbind('focus', _onFocus);
            scope._input_.unbind('blur', _onBlur);
          });
        },
        templateUrl: 'lm-tags/lm-tags.tpl.html'
      };
    }]);
